import { action } from '@/utils/actions.utils'

export const SET_FORM_VALUE = 'SET_FORM_VALUE'
const setValue = (fieldName, value, formId = null) => {
	return action(SET_FORM_VALUE, { fieldName, value, formId })
}

export const UNSET_FORM_VALUE = 'UNSET_FORM_VALUE'
const unsetValue = (fieldName, value, formId = null) => {
	return action(UNSET_FORM_VALUE, { fieldName, value, formId })
}

export default {
	setValue,
	unsetValue
}
